import { z } from 'zod';

/**
 * How a seat subscription's trial runs before its first payment.
 *
 * - `none`   — nothing is free; the plan unlocks when the invoice is paid.
 * - `days`   — the plan works until `Subscription.trialEndsAt`.
 * - `orders` — the plan covers the first `orders` orders; `ordersUsed`
 *   counts them (one per order, refunded when the order is reversed).
 *
 * Absent on subscriptions written before trials were configurable; those
 * follow the global `entitlementGate.trialCountsAsPaid` rule.
 */
export const subscriptionTrialSchema = z.object({
  by: z.enum(['none', 'days', 'orders']),
  orders: z.coerce.number().int().min(0).optional(),
  ordersUsed: z.coerce.number().int().min(0).optional(),
});
export type SubscriptionTrial = z.infer<typeof subscriptionTrialSchema>;
